import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { AuthCallbackView } from "../features/auth/index.ts";

export const AuthCallback: FC = () => (
  <PageContainer>
    <AuthCallbackView />
  </PageContainer>
);
